import React, { ReactNode } from 'react';
import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';
import { FaSackDollar } from "react-icons/fa6";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { BiDollarCircle } from "react-icons/bi";

interface RequestStatCardProps {
  totalRequest?: number;
  numberOfRequest: string;
  label: string;
  bgColour: string;  
}

const RequestIconStatCard: React.FC<RequestStatCardProps> = ({totalRequest, numberOfRequest, label, bgColour}) => {

    const valueStyle = `text-right text-title-[20px] text-black font-bold dark:text-white`
    const requestStyle = `w-8 h-8 rounded-full flex items-center justify-center ${bgColour}`

    const tots = totalRequest;

    return (
        <div className="rounded-sm border border-stroke bg-white py-[13px] px-4 shadow-default dark:border-strokedark dark:bg-boxdark">
            <div className="flex items-end justify-between">
                <div className={requestStyle}>
                    <BiDollarCircle className="text-white" />
                </div>
                <div>
                    <h3 className={valueStyle}>{numberOfRequest} </h3>
                    <div className="text-right font-normal text-slate-500">{label}</div>
                </div>        
            </div>
            
        </div>        
    );
};

export default RequestIconStatCard;
